<template lang="pug">
  .wrap
    page-title Manage Report Types

    .top-actions
      el-button(@click='addCategory' size='large') Add Category
      el-button(@click='saveChanges' type='primary' size='large') Save changes

    .section
      .items.categories
        .item(v-for='(category, categoryIndex) in list' v-if='!category.deleted' :key='categoryIndex')
          .item-title.category
            icon.arrow(name='angle-right' color='#dd6e69' :scale='1.5')

            .label(v-if='!category.editing' @click='startEditing(category)')
              | {{ category.name || 'No name' }}
            .name-editor(v-else)
              el-input.name-input(v-model='category.name' placeholder='Enter name...'
                @keyup.native.enter='finishEditing(category)' @blur='finishEditing(category)' autofocus)

            .actions
              .action
                el-button(@click='startEditing(category)') Edit
              .action
                el-button(@click='addType(categoryIndex)') Add Sub-category
              .action
                el-button(@click='deleteItem(category)') Delete

          .items.types
            .item(v-for='(type, typeIndex) in category.issueTypes' v-if='!type.deleted' :key='typeIndex')
              .item-title.type
                icon.arrow(name='angle-right' color='#ccc' :scale='1.5')

                .label(v-if='!type.editing' @click='startEditing(type)')
                  | {{ type.name || 'No name' }}
                .name-editor(v-else)
                  el-input.name-input(v-model='type.name' placeholder='Enter name...'
                    @keyup.native.enter='finishEditing(type)' @blur='finishEditing(type)' autofocus)

                .actions
                  .action
                    el-button(@click='addReason(categoryIndex, typeIndex)') Add Reason
                  .action
                    el-button(@click='startEditing(type)') Edit
                  .action
                    el-button(@click='deleteItem(type)') Delete

              .items.reasons
                .item(v-for='(reason, reasonIndex) in type.issueReasons' v-if='!reason.deleted' :key='reasonIndex')
                  .item-title.reason
                    icon.arrow(name='minus' color='#ddd' :scale='1')

                    .label(v-if='!reason.editing' @click='startEditing(reason)')
                      | {{ reason.name || 'No name' }}
                    .name-editor(v-else)
                      el-input.name-input(v-model='reason.name' placeholder='Enter name...'
                        @keyup.native.enter='finishEditing(reason)' @blur='finishEditing(reason)' autofocus)

                    .actions
                      .action
                        el-button(@click='startEditing(reason)') Edit
                      .action
                        el-button(@click='deleteItem(reason)') Delete

                .empty.reasons(v-if='!type.issueReasons.length') No Reasons

            .empty.types(v-if='!category.issueTypes.length') No Types

        .empty.categories(v-if='!list.length') No Categories yet

</template>

<script>
/* eslint no-param-reassign: 0 */

import Vue from "vue";
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import CrudMixin from "@/shared/mixins/Crud";

export default {
  mixins: [CrudMixin],
  components: { PageTitle },
  data() {
    return {
      loading: true,
      list: []
    };
  },
  computed: {
    showPlaceholder() {
      return !this.loading && !this.list.length;
    }
  },
  methods: {
    ...mapActions("issues", ["fetchIssueCategories", "updateCategoryTree"]),
    loadList({ params } = {}) {
      const mergedParams = {
        ...params
      };
      this.loading = true;
      this.fetchIssueCategories({ params: mergedParams }).then(data => {
        this.loading = false;
        this.list = data;
      });
    },
    saveChanges() {
      this.wrapApiAction(this.updateCategoryTree)({ data: this.list }).then(
        data => {
          this.list = data;
          return data;
        }
      );
    },
    addCategory() {
      this.list.push({
        name: "",
        editing: true,
        issueTypes: []
      });
    },
    addType(categoryIndex) {
      this.list[categoryIndex].issueTypes.push({
        name: "",
        editing: true,
        issueReasons: []
      });
    },
    deleteItem(item) {
      Vue.set(item, "deleted", true);
    },
    addReason(categoryIndex, typeIndex) {
      this.list[categoryIndex].issueTypes[typeIndex].issueReasons.push({
        name: "",
        editing: true
      });
    },
    startEditing(item) {
      Vue.set(item, "editing", true);
    },
    finishEditing(item) {
      Vue.set(item, "editing", false);
    }
  },
  created() {
    this.loadList();
  }
};
</script>

<style scoped lang="scss">
.top-actions {
  margin-bottom: 20px;
}

.item-title {
  font-size: 16px;
  border-bottom: 1px solid #ddd;
  padding: 5px 0 5px 0;
  height: 50px;
  display: flex;
  align-items: center;
  transition: background 250ms ease-in-out;

  &.category {
    font-size: 14px;
    padding-left: 20px;
    background: #eff0f2;
    font-family: "gilroyextrabold";
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  &.type {
    font-size: 16px;
    padding-left: 35px;
  }

  &.reason {
    font-size: 16px;
    color: #666;
    padding-left: 55px;
  }

  &:hover {
    .actions {
      opacity: 1;
    }
  }
}

.arrow {
  margin-right: 10px;
}

.empty {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666;
  padding: 10px 0;
  font-style: italic;

  &.categories {
    padding: 40px;
  }

  &.types {
    padding-left: 35px;
  }

  &.reasons {
    padding-left: 55px;
  }
}

.label {
  cursor: pointer;
}

.actions {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 20px;
  opacity: 0;
  transition: opacity 250ms ease-in-out;
}

.action {
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
}

.section {
  border: 1px solid #ddd;
  background: white;
}

.name-input {
  width: 400px;
}
</style>
